import * as React from 'react';

// Styles
import './styles/FlexLaneBadge.scss';

// TEMPORARY (#14675). FlexLane (Koala CFAR) lets a traveller cancel an otherwise non-refundable
// booking up to 24h before travel. Until the real design ships with the frontend redesign, an
// eligible fare is marked "FLEXLANE" so the team can confirm in staging that eligibility lands on
// the right fares - flights and trains carry it in the fare name, hotel rates carry the `flexlane`
// flag and get this badge, because their only name (room_type) is what the rates list groups and
// filters by. Deliberately not translated: FLEXLANE is the product codename and has to read exactly
// like the backend marker it mirrors.
const LABEL = 'FLEXLANE';

type Props = {
  flexlane?: boolean;
};

export const FlexLaneBadge: React.FC<Props> = ({ flexlane }) => {
  if (!flexlane) {
    return null;
  }

  return <span className="flexlane-badge">{LABEL}</span>;
};
